import { translate as t } from '@thoughtspot/i18n';
import { Select } from '@thoughtspot/radiant-react/widgets/select';
import React, { useCallback } from 'react';
export const LiveboardSelector = ({ onSelect, disabled = false, options, loading, onSearchInput, }) => {
    const handleSearchInput = useCallback((input) => {
        onSearchInput(input);
    }, [onSearchInput]);
    const handleChange = useCallback((option) => {
        onSelect({
            id: option.id,
            name: option.label,
        });
        onSearchInput('');
    }, [onSelect, onSearchInput]);
    const optionsGroups = [
        {
            options: options.map(liveboard => ({
                id: liveboard.id,
                label: liveboard.name || liveboard.id,
            })),
        },
    ];
    return (React.createElement(Select.Dropdown, { id: "liveboard-selector", "data-testid": "liveboard-cache-selector", isSearchEnabled: true, onSearchInput: handleSearchInput, selectedOptions: [], optionsGroups: optionsGroups, dropdownWidth: "targetWidth", loading: loading, placeholder: t('EmbedDev.Playground.Knobs.selectPinboard'), onChange: handleChange, disabled: disabled }));
};
//# sourceMappingURL=liveboard-selector.js.map